// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"570d2db8","346":"c28792c9","363":"8a54712c","586":"c7e3ad3f","646":"cc554a87"}[chunkId] + ".chunk.js";
};